module.exports = __webpack_public_path__ + "img/help_img.d43bd0d6.png";